import { api } from './api';
import axios from 'axios';

export enum NavPage {
  HOME = 'home',
  DASHBOARDS = 'dashboards',
  INSIGHTS = 'insights',
  STRATEGY = 'strategy',
  REQUESTS = 'requests',
  PROGRAMS = 'programs',
  PROJECTS = 'projects',
  TASKS = 'tasks',
  SCHEDULE = 'schedule',
  DESIGN = 'design',
  EVALUATIONS = 'evaluations',
  TEAMS = 'teams',
  BUDGET = 'budget',
  SETTINGS = 'settings',
}

export interface NavItem {
  page: NavPage;
  canShow: boolean;
}

export interface NavItemsResponse {
  data: NavItem[];
}

export const getNavItems = async (): Promise<NavItemsResponse> => {
  const url = `/v2/nav`;
  const response = await api.get<NavItemsResponse>(url);
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response.data;
};
